var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2762 9.05116C6.6345 8.70664 7.20424 8.71781 7.54875 9.07611L12 13.8014L16.4513 9.07611C16.7958 8.71781 17.3655 8.70664 17.7238 9.05116C18.0821 9.39567 18.0933 9.96541 17.7487 10.3237L12.6488 15.7237C12.4791 15.9002 12.2448 15.9999 12 15.9999C11.7552 15.9999 11.5209 15.9002 11.3513 15.7237L6.25125 10.3237C5.90674 9.96541 5.91791 9.39567 6.2762 9.05116Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.69a108c86eeef0c03aaad0fa54514023.svg";
export { ForwardRef as ReactComponent };